module.exports = __webpack_public_path__ + "img/mobile_popup.4c92f39d.png";